import { withInstall } from '@zoryn/utils'
import Image from './src/image.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZImage: SFCWithInstall<typeof Image> = withInstall(Image)
export default ZImage

export * from './src/image'
